import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
export const MultiBox = ({ inputProps = {}, onChange, checked, required, label, labelClass = '', error, dense }) => {
    const inputRef = React.useRef(null);
    const checkedRef = React.useRef(checked);
    const updateInput = (ref, checked) => {
        const input = ref.current;
        if (input) {
            input.checked = checked;
            input.indeterminate = checked == null;
        }
    };
    React.useEffect(() => {
        checkedRef.current = checked;
        updateInput(inputRef, checked);
    }, [checked]);
    const handleClick = () => {
        switch (checkedRef.current) {
            case true:
                checkedRef.current = false;
                break;
            case false:
                checkedRef.current = undefined;
                break;
            default: // null
                checkedRef.current = true;
                break;
        }
        updateInput(inputRef, checkedRef.current);
        if (onChange) {
            onChange(checkedRef.current);
        }
    };
    return (_jsxs("div", { className: "relative w-full", children: [_jsxs("div", { className: `flex ${dense ? 'items-center' : 'items-start'} ${inputProps.disabled ? '!opacity-60' : ''}`, children: [_jsx("div", { className: "group", children: _jsxs("div", { className: `relative ${dense ? 'size-4' : 'size-5'} rounded border-2 border-opacity-60${checkedRef.current == true ? 'border-primary-400 bg-primary-400 group-hover:border-primary-400' : ''}${checkedRef.current == false ? 'border-delete bg-delete group-hover:border-delete' : ''}${checkedRef.current == undefined ? 'group-hover:border-primary-400 border-black bg-transparent' : ''}${inputProps.disabled ? '!border-gray-400 !bg-gray-400 hover:!border-gray-400' : ''}`, children: [_jsx("input", { className: "absolute inset-0 z-10 cursor-pointer opacity-0", ref: inputRef, id: inputProps.name || inputProps.id || undefined, required: required, type: "checkbox", onClick: handleClick }), _jsx("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: checked == true && _jsx(CheckIcon, { className: "size-4 text-white" }) }), _jsx("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: checked == false && _jsx(XMarkIcon, { className: "size-4 text-white" }) })] }) }), _jsxs("label", { htmlFor: inputProps.name || inputProps.id || undefined, className: `${dense ? 'ml-1 text-sm' : 'ml-2'} block cursor-pointer text-gray-700 ${inputProps.disabled ? '!text-gray-400' : ''} ${labelClass}`, children: [label, required && _jsx("span", { className: "ml-0.5 inline-block text-gray-500", children: "*" })] })] }), error ? _jsx("p", { className: "mx-3.5 mt-1 text-xs text-[#F44336]", children: error?.message }) : null] }));
};
//# sourceMappingURL=Multibox.js.map